// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  /* api_url: 'https://aya.globalwavetechnology.com/business_license/service/ServiceRequest/',
  auth_url: 'https://aya.globalwavetechnology.com/business_license/service/',
  file_url: 'https://aya.globalwavetechnology.com/business_license/service/FileServiceRequest/' */

  api_url: 'https://app.ayarwadydevelopment.gov.mm/business_license/service/ServiceRequest/',
  auth_url: 'https://app.ayarwadydevelopment.gov.mm/business_license/service/',
  file_url: 'https://app.ayarwadydevelopment.gov.mm/business_license/service/FileServiceRequest/'

  /* api_url: 'http://localhost:8080/AYADC/business_license/public_service/ServiceRequest/',
  auth_url: 'http://localhost:8080/AYADC/business_license/public_service/',
  file_url: 'http://localhost:8080/AYADC/business_license/public_service/FileServiceRequest/' */
};
